import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(lang_en);

    /** @ngInject */
    function lang_en($translateProvider) {
        $translateProvider.translations('en', {
            HELLO: 'Hello world po angielsku',
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/translations/translation_en.ts